import React, { useState, useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import { Form } from "../components/general/form.js";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/authContext";

export default function Login() {
  // const [user, setUser] = useState();
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [formData, setFormData] = useState(
    {
      email: "",
      password: ""
    }
  );

  const images = [
    require("../assets/images/girl-laptop.jpg"),
    require("../assets/images/men-happy.jpg"),
    require("../assets/images/girl-microwave.jpg"),
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);


  // This passes the test
const handleEmailSignIn = async () => {
  setLoading(true);
  const data = {
    email: (formData.email || "").trim().toLowerCase(),
    password: formData.password,
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(data.email)) {
    toast.error("Please enter a valid email address.");
    setLoading(false);
    return;
  }

  try {
    const response = await login(data);
    const loggedInUser = response?.user;
    saveProfileSetupData(loggedInUser, data.email);
    navigate("/dashboard");
    console.log(user);
    setErrorMessage(""); 
  } catch (error) {
    if (error.message === "Invalid credentials") {
      const message = "Invalid email or password";  
      setErrorMessage(message);
      toast.error(message, { duration: 5000 });
    } else if (error.message === "You don't have access here") {
      toast.error("You don't have access here", { duration: 5000 });
    } else {
      toast.error(error.message || "Something went wrong.", { duration: 5000 });
    }
  } finally {
    setLoading(false);
  }
};

const saveProfileSetupData = (user, fallbackEmail) => {
  sessionStorage.setItem(
    "landlord_profile_setup",
    JSON.stringify({
      businessName: user?.name || "",
      email: user?.email || fallbackEmail || "",
      phoneNumber: user?.phone_number || user?.phoneNumber || "",
      network: user?.network || "",
    }),
  );
};

  // Fails the test
  // const handleEmailSignIn = async () => {
  //   setLoading(true);
  //   const data = {"email": formData.email, "password": formData.password}
  //   try {
  //     await login(data);
  //     // const emailUser = await logInWithEmailAndPassword(formData.email, formData.password);
  //     // setUser(emailUser);
  //     console.log(user);
  //   } catch (error) {
  //     toast.error(`${error.message}`, {duration: 5000});
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const formFields = [
    { type: "text", name: "email", label: "Email", placeholder: "Enter email", value: formData.email, required: true },
    { type: "password", name: "password", label: "Password", placeholder: "Enter password", value: formData.password, required: true },
  ];

  return (  
    <div className="relative h-screen w-screen flex flex-col items-center justify-center bg-black">
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`slide-${index}`}
            className={`absolute w-full h-full object-cover transition-opacity duration-1000 ${index === currentImage ? 'opacity-100' : 'opacity-0'}`}
          />
        ))}
      </div>

      
      <div className="z-20 top-32">
        <img src={require("../assets/images/logo-white.png")} alt="NanoWattz Logo" width={250} />
      </div>

      {/* Pagination Indicator (WhatsApp Status Style) */}
      <div className="absolute top-4 left-0 w-full flex gap-2 px-4 z-20">
        {images.map((_, index) => (
          <div
            key={index}
            className="h-1 flex-1 rounded-full bg-white relative overflow-hidden"
          >
            {/* Filler animation only on the current image */}
            {index <= currentImage && (
              <div
                className={`absolute left-0 top-0 h-full bg-primary-normal transition-all duration-[5000ms]`}
                style={{
                  width: index === currentImage ? "100%" : "100%",
                  animation: index === currentImage ? "fillProgress 5s linear forwards" : "none",
                }}
              ></div>
            )}
          </div>
        ))}
      </div>
      <style>
        {`
          @keyframes fillProgress {
            from { width: 0%; }
            to { width: 100%; }
          }
        `}
      </style>

      {/* Login Form */}
      <div className="relative bg-black p-8 mt-5 rounded-xl shadow-xl w-full max-w-md z-20 bg-opacity-50">
        <h2 className="text-center font-nexa text-2xl font-bold text-white mb-6">Log in</h2>
        <Form
          fields={formFields}
          onSubmit={handleEmailSignIn}
          formData={formData}
          setFormData={setFormData}
          btnText="Login"
          isLoading={loading}
          className="bg-opacity-50"
        />

        {/* This is where the error message is displayed (You will need to start using your own components to make life easier for you when writing unit Tests) */}
         {errorMessage && (
         <p data-testid="error-message" className="text-red-500 text-center mt-3">
          {errorMessage}
         </p>
       )}
        <div className="z-20 mt-2 cursor-pointer" onClick={() => navigate('/reset-password')}>
          <p className="font-nexa w-full text-white">Forgot password?</p>
        </div>
        <div className="z-20 mt-2 cursor-pointer" onClick={() => navigate('/create-account')}>
          <p className="font-nexa w-full text-white">
            New landlord? Create an account
          </p>
        </div>
      </div>
      <div className="absolute z-20 bottom-5">
        <p className="font-nexa w-full text-center text-white">All rights reserved {" "}
          <a className="text-white hover:text-primaryDull decoration-transparent" href="/about" target="_blank" >THE GRID 1.0</a>
        </p>
      </div>
      <Toaster position="top-center" />
    </div>
  );
}
